import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import request, { getImageSrc } from '../utils/request';
import Layout from '../components/Layout';
import { AIMATCH_TAB_ACTIVATE } from '../utils/tabActivate';
import './Activities.css';

function Activities() {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchActivities = useCallback(async (opts = {}) => {
    const silent = opts.silent === true;
    if (!silent) setLoading(true);
    try {
      const res = await request({
        url: '/api/activity/list',
        method: 'GET'
      });
      setActivities(res.data);
    } catch (err) {
      console.error('获取活动列表失败:', err);
    } finally {
      if (!silent) setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchActivities({ silent: false });
  }, [fetchActivities]);

  useEffect(() => {
    const onTab = (e) => {
      if (e.detail?.path === '/activities') fetchActivities({ silent: true });
    };
    window.addEventListener(AIMATCH_TAB_ACTIVATE, onTab);
    return () => window.removeEventListener(AIMATCH_TAB_ACTIVATE, onTab);
  }, [fetchActivities]);

  const formatPrice = (price) => {
    return `¥${(price / 100).toFixed(2)}`;
  };

  if (loading) {
    return (
      <Layout>
        <div className="container">加载中...</div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="container">
        <div className="header">
          <h2>🎉 近期活动</h2>
          <p className="subtitle">早报名享优惠</p>
        </div>

      {activities.length === 0 ? (
        <div className="empty-state">
          <p>暂无进行中的活动</p>
        </div>
      ) : (
        <div className="activity-list">
          {activities.map(activity => (
            <div 
              key={activity.id} 
              className="activity-card"
              onClick={() => navigate(`/activity/${activity.id}`)}
            >
              <div className="card-image">
                {activity.cover_image ? (
                  <img
                    src={getImageSrc(activity.cover_image)}
                    alt={activity.title}
                  />
                ) : (
                  <div className="card-image-placeholder">
                    <span>🎉</span>
                  </div>
                )}
                {activity.signupClosed ? (
                  <span className="hot-tag" style={{ background: '#94a3b8' }}>报名已截止</span>
                ) : activity.remainingSlots !== '不限' && activity.remainingSlots < 20 && (
                  <span className="hot-tag">仅剩{activity.remainingSlots}席</span>
                )}
              </div>
              
              <div className="card-content">
                <h3>{activity.title}</h3>
                
                <div className="info-line">
                  <span className="icon">📅</span>
                  <span>{new Date(activity.start_time).toLocaleString('zh-CN', {
                    month: 'numeric',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}</span>
                </div>
                
                <div className="info-line">
                  <span className="icon">📍</span>
                  <span>{activity.location_name}</span>
                </div>
                
                <div className="price-line">
                  <span className="current-price">{formatPrice(activity.currentPrice)}</span>
                  {activity.currentPrice < activity.originalPrice && (
                    <>
                      <span className="original-price">{formatPrice(activity.originalPrice)}</span>
                      <span className="discount-tag">早鸟价</span>
                    </>
                  )}
                </div>
                
                {activity.priceDescription && (
                  <div className="price-desc">{activity.priceDescription}</div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      </div>
    </Layout>
  );
}

export default Activities;